const e = {
  "en-gb": {
    phoneNumber: "+447441440889",
    schedule: "Mon. - Fri. : 7:30 - 22:00",
    timezone: "Europe/London",
    hours: { start: 7.5, end: 22 }
    // 7:30am to 22:00pm
  },
  "de-de": {
    phoneNumber: "+493056796091",
    schedule: "Mon. - Fri. 8:00 - 21:00",
    timezone: "Europe/Berlin",
    hours: { start: 8, end: 21 }
    // 8:00am to 21:00pm
  }
};
export {
  e as WHATSAPP_CONFIG
};
//# sourceMappingURL=contact-channels72.js.map
